import { useState, useEffect, useContext, useCallback } from "react";

//Context
import { AuthContext } from "../middlewares/Auth";

//Librerias
import axios from "axios";
import { toast } from "react-hot-toast";

const usePersonaActiva = ({ strEmailColaborador, strArea, strUEN }) => {
    //===============================================================================================================================================
    //========================================== Declaracion de estados =============================================================================
    //===============================================================================================================================================
    const [data, setData] = useState();

    //===============================================================================================================================================
    //========================================== Context ============================================================================================
    //===============================================================================================================================================
    const { token } = useContext(AuthContext);

    //===============================================================================================================================================
    //========================================== Funciones  =========================================================================================
    //===============================================================================================================================================
    const getData = useCallback(
        async (signalSubmitData) => {
            await axios(
                {
                    method: "GET",
                    baseURL: `${process.env.REACT_APP_API_BACK_PROT_DATALAKE}://${process.env.REACT_APP_API_BACK_HOST_DATALAKE}${process.env.REACT_APP_API_BACK_PORT_DATALAKE}`,
                    url: `${process.env.REACT_APP_API_PERSONAACTIVA_GETPERSONAACTIVAFULL}`,
                    headers: {
                        token,
                    },
                    params: {
                        strEmail: strEmailColaborador,
                        strArea,
                        strUEN,
                    },
                },
                {
                    cancelToken: signalSubmitData.token,
                }
            )
                .then((res) => {
                    setData(res.data.data?.[0]);
                })
                .catch((error) => {
                    if (!axios.isCancel(error)) {
                        let msg;

                        if (error.response) {
                            msg = error.response.data.msg;
                        } else if (error.request) {
                            msg = error.message;
                        } else {
                            msg = error.message;
                        }

                        // toast.error(msg);

                        setData({
                            error: true,
                            msg,
                        });
                    }
                });
        },
        [token, strArea, strUEN, strEmailColaborador]
    );

    const refreshGetData = () => {
        let signalSubmitData = axios.CancelToken.source();

        setData();

        getData(signalSubmitData);
    };

    //===============================================================================================================================================
    //========================================== useEffects =========================================================================================
    //===============================================================================================================================================
    useEffect(() => {
        let signalSubmitData = axios.CancelToken.source();

        getData(signalSubmitData);

        return () => {
            signalSubmitData.cancel("Petición abortada.");
        };
    }, [getData]);

    //===============================================================================================================================================
    //========================================== Returns ============================================================================================
    //===============================================================================================================================================
    return { data, refreshGetData };
};

/**
 * El hook devuelve un listado de las personas activas en la compañia
 *
 * @author Liseth Arelis Giraldo Morales <lgiraldom@choucairtesting.com>
 * @param {{strEmailColaborador: string, strArea: string, strUEN: string}} 
 * - Parámetros de busqueda:
 * - `strEmailColaborador`  Utilice el parámetro en caso de buscar la información de un colaborador en específico.
 * - `strArea`  Utilice el parámetro en caso de querer obtener un listado de personas asociadas a un area en específico.
 * - `strUEN`  Utilice el parámetro en caso de querer obtener un listado de personas asociadas a una UEN en específico.
 * @returns {{data: object, refreshGetData: function}} 
 * `data` Devuelve un objeto con las información del colaborador
 * `refreshGetData` Devuelve función para llamar nuevamente a la API
 * `getUniqueData` Devuelvue función para llamar por un registro en especifico.
 * @example
 * Objeto con los datos
   {
    "error": false,
    "data": [
        {
            "strEmail": "lgiraldom@choucairtesting.com",
            "strIdentificacion": "1036965346",
            "strNombreCompleto": "Liseth Arelis Giraldo Morales",
            "strCargo": "Aprendices",
            "strCcosto": "1101000000"
        }
    ]
   }  
 * @example
    Función que permite realizar el llamada a la API
    function refreshGetData()
 *
 */
export default usePersonaActiva;
